import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { UiUniformUpdateNameDialogComponent, UiUniformUpdateNameDialogData, UiUniformUpdateNameDialogResult } from './ui-uniform-update-name-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class UiUniformUpdateNameDialogService {

  constructor(private dialog: MatDialog) {}

  open(data: UiUniformUpdateNameDialogData): Observable<UiUniformUpdateNameDialogResult | undefined> {
    return this.dialog.open(UiUniformUpdateNameDialogComponent, {
      data,
      minWidth: '400px',
      maxWidth: '500px',
      panelClass: ['modal-no-padding', 'z-index-1001'],
      disableClose: false
    }).afterClosed();
  }
} 